import { WindowService } from '@i-wyze/ui-shared-library';
import { computed, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppWindowService extends WindowService {
	public isInCompactMode = computed(() => this.isMobile() || this.isTablet());
}
